module.exports = __webpack_public_path__ + "img/fz-6.10df479e.png";